import React from 'react'
import { useConnection, useTick } from './ConnectionContext'
import { formatAge, formatClock } from './format'

export interface StaleBannerProps {
  className?: string
}

/**
 * Banner (Slot `banner` der AppShell): gelb bei veralteten Daten bzw. gestörter Verbindung,
 * rot bei fehlender Verbindung; jeweils mit "Erneut versuchen". Bei ok/unknown unsichtbar.
 * Die Schwelle "veraltet" wird am ConnectionProvider (staleMs) pro Modul festgelegt.
 */
export function StaleBanner({ className }: StaleBannerProps) {
  const c = useConnection()
  const show = c.level === 'stale' || c.level === 'degraded' || c.level === 'offline'
  const now = useTick(1000, show)
  if (!show) return null
  const age = c.lastSuccessAt === null ? null : Math.max(0, now - c.lastSuccessAt)
  const seit = c.lastSuccessAt === null ? '' : ` Letzte Antwort ${formatClock(c.lastSuccessAt)} (${formatAge(age)}).`

  let text: string
  if (c.level === 'offline') text = (c.online ? 'Keine Verbindung zum Server – angezeigte Daten können veraltet sein.' : 'Das Gerät ist offline – angezeigte Daten können veraltet sein.') + seit
  else if (c.level === 'degraded') text = 'Verbindung gestört – Daten werden erneut abgerufen.' + seit
  else text = `Daten veraltet seit ${formatClock(c.lastSuccessAt)} (${formatAge(age)}).`

  const danger = c.level === 'offline'
  return (
    <div className={`ui-banner ${danger ? 'ui-banner--danger' : 'ui-banner--warn'} ${className ?? ''}`} role={danger ? 'alert' : 'status'}>
      <span className="ui-banner-txt">{text}</span>
      <button type="button" className="ui-banner-btn" onClick={c.retry}>Erneut versuchen</button>
    </div>
  )
}
